import React, { useContext, useState, Fragment, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Image } from '../../AbstractElements';
import CheckContext from '../../_helper/Customizer';
import { AccountContext } from '../../GlobalComponents/Authentication/Accounts';

const Leftbar = () => {

    const { userSession } = useContext(AccountContext);
    const { mixLayout } = useContext(CheckContext);
    const [toggle, setToggle] = useState(false);

    const toggleMobileSidebar = () => {
        const sidebar = document.querySelector('header.main-nav');
        const overlay = document.getElementById('bg-overlay1');

        if (sidebar && overlay) {
            if (sidebar.classList.contains('close_icon')) {
                sidebar.classList.remove('close_icon');
                overlay.classList.add('active');
            } else {
                sidebar.classList.add('close_icon');
                overlay.classList.remove('active');
            }
        }
    };

    // Close sidebar when clicking overlay
    useEffect(() => {
        const overlay = document.getElementById('bg-overlay1');
        const handleOverlayClick = () => {
            const sidebar = document.querySelector('header.main-nav');
            if (sidebar && overlay) {
                sidebar.classList.add('close_icon');
                overlay.classList.remove('active');
            }
        };

        if (overlay) {
            overlay.addEventListener('click', handleOverlayClick);
        }

        return () => {
            if (overlay) {
                overlay.removeEventListener('click', handleOverlayClick);
            }
        };
    }, []);

    return (
        <Fragment>
            <div className="main-header-left">
                {/* Mobile burger button for sidebar toggle */}
                <div className="d-lg-none mobile-toggle" onClick={toggleMobileSidebar} style={{cursor: 'pointer', display: 'flex', padding: '15px'}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="status_toggle middle">
                        <line x1="18" y1="10" x2="6" y2="10"></line>
                        <line x1="21" y1="6" x2="3" y2="6"></line>
                        <line x1="21" y1="14" x2="3" y2="14"></line>
                        <line x1="18" y1="18" x2="6" y2="18"></line>
                    </svg>
                </div>

                {mixLayout ?
                    <div className="logo-wrapper">
                        <Link to={`${process.env.PUBLIC_URL}/dashboard`}>
                            <Image attrImage={{ className: 'img-fluid d-inline', src: 'https://s3.amazonaws.com/portal.nexnow.io/NexNow_Logo_clear.png', alt: '' }} />
                        </Link>
                    </div>
                    :
                    <div className="dark-logo-wrapper">
                        <Link to={`${process.env.PUBLIC_URL}/dashboard`}>
                            <Image attrImage={{ className: 'img-fluid d-inline', src: 'https://s3.amazonaws.com/portal.nexnow.io/NexNow_Logo_clear.png', alt: '' }} />
                        </Link>
                    </div>
                }

            </div>
        </Fragment >
    );
};

export default Leftbar;